import * as serviceWorker from "./serviceWorker";
import React from "react";
import ReactDOM, { render } from "react-dom";
import App from "./App";
import "./index.css";
import { HashRouter } from "react-router-dom";
import store from "./redux/redux-store";
import { Provider } from "react-redux";


ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister(); 
